import React, { useState } from "react";
import { TextField, IconButton } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckIcon from "@mui/icons-material/Check";

/** Read-only field with a copy-to-clipboard button — shared by the chat widget's create and rotate-key secret reveals. */
// `hideLabel` + `sx` are opt-in (Rahim, 2026-09-23): the Website Chat wizard puts
// its own label above the field (LabeledField) and styles the input with
// inboxInputSx, so it drops MUI's floating label. Defaults keep the rotate-key
// dialog exactly as before.
const CopyField = ({ label, value, hideLabel = false, sx }) => {
  const [copied, setCopied] = useState(false);
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (e) {
      // Clipboard API unavailable/denied — value is still selectable/visible in the field itself.
    }
  };
  return (
    <TextField
      fullWidth
      label={hideLabel ? undefined : label}
      value={value}
      sx={sx}
      inputProps={{ "aria-label": label }}
      InputProps={{
        readOnly: true,
        // Body Emphasis token (0.9375rem) — matches every other "typed/displayed
        // value" field app-wide (Inbox scale), was an off-scale 0.9rem.
        sx: { fontFamily: "monospace", fontSize: "0.9375rem" },
        endAdornment: (
          <IconButton onClick={handleCopy} size="small" edge="end">
            {copied ? <CheckIcon fontSize="small" color="success" /> : <ContentCopyIcon fontSize="small" />}
          </IconButton>
        ),
      }}
    />
  );
};

export default CopyField;
